import React from 'react'

interface SmallBadgeButtonProps {
  label: string
  onClick?: () => void
  variant?: 'default' | 'outline' | 'inverse'
}

const SmallBadgeButton: React.FC<SmallBadgeButtonProps> = ({
  label,
  onClick,
  variant = 'default',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        px-16px py-8px
        rounded-8px
        transition-all
        font-pretendard font-700 text-14px leading-none text-center
        ${onClick ? 'cursor-pointer' : 'cursor-default'}
        ${
          variant === 'default' &&
          'border border-brown-80%-main bg-brown-80%-main text-textColorText1W'
        }
        ${
          variant === 'outline' &&
          'border border-brown-80%-main bg-ctaTertiary text-brown-80%-main'
        }
        ${
          variant === 'inverse' &&
          'border-none bg-472410-10% text-brown-80%-main'
        }
      `}
    >
      {label}
    </button>
  )
}

export default SmallBadgeButton
